import React from 'react'
import BybPrivacyPolicy from './BybPrivacyPolicy/BybPrivacyPolicy'
import PageSeo from '../Common/Seo/PageSeo'

const PrivacyPolicyPage = () => {
  return (
    <div>
        <PageSeo
          title="Privacy Policy | Brew Your Brand"
          description="Read the Brew Your Brand privacy policy to understand how we collect, use, and protect information across our branding tools, resources, and services."
          canonical="/privacy-policy"
          ogTitle="Privacy Policy | Brew Your Brand"
        />
        <BybPrivacyPolicy/>
    </div>
  )
}

export default PrivacyPolicyPage
